import { render, staticRenderFns } from "./stripe.vue?vue&type=template&id=383520ad&scoped=true&"
import script from "./stripe.vue?vue&type=script&lang=js&"
export * from "./stripe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383520ad",
  null
  
)

export default component.exports